export enum ContractCodes {
    GJENSIDIGE = '181',
    OKQ8 = '202',
    VILLAAGARNA = '101'
}

export default ContractCodes;
